import styled, { css } from 'styled-components/macro';
import { Container } from '@yme/atoms/grid';
import { colorCoreGray500, colorCoreWhite1000, colorWhiteTransparent300 } from '@yme/tokens/colors';
import { CORNER_RADIUS } from '@yme/tokens/cornerRadius';
export const boxStyled = css `
  border-radius: ${CORNER_RADIUS.s};
  border: 1px solid ${colorCoreGray500};
  background: ${colorWhiteTransparent300};
  display: flex;
  align-items: center;
  padding: 8px;
  box-sizing: border-box;

  &:hover {
    background: ${colorCoreWhite1000};
  }
`;
export const ContainerStyled = styled(Container) `
  height: auto;
  min-height: 124px;

  transition: height 1.3s ease-in-out, min-height 0.5s ease-in-out;
`;
